<template>
	<v-container fluid>
		<slot name="prepend" v-bind="{ value, setValue, itemsToArchive, updateItemsToArchive }"></slot>
		<v-form ref="form">
			<slot name="form" v-bind="{ value, setValue, itemsToArchive, updateItemsToArchive }"></slot>
		</v-form>
		<slot name="append" v-bind="{ value, setValue, itemsToArchive, updateItemsToArchive }"></slot>
		<standard-actions
			class="mt-4"
			:payload="value"
			v-bind="editorActions"
			:saveDialogMayOpenHook="saveDialogMayOpenHookInternal"
			save
			cancel
			@save="save"
			@cancel="cancel"
			@release="$emit('release', $event)"
		/>
	</v-container>
</template>

<script>
// globals
// locals
import i18n from './dictionary';
// models
// components
import StandardActions from '@/components/base/standardActions/StandardActions.vue';

// todo: implement validation in this component

export default {
	name: `CrudEditor`,
	components: { StandardActions },
	mixins: [],
	i18n,
	props: {
		value: {
			type: Object,
			required: true,
		},
		optionName: {
			type: String,
			required: false,
		},
		match: {
			type: Object,
			required: false,
		},
		beforeSaveHook: {
			type: Function,
			required: false,
		},
		afterSaveHook: {
			type: Function,
			required: false,
		},
		saveDialogMayOpenHook: {
			type: Function,
			default: () => true,
		},
		editorActions: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			itemsToArchive: [],
		};
	},
	computed: {
		editorItem: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {
		saveDialogMayOpenHookInternal() {
			const hookAllowsOpen = this.saveDialogMayOpenHook({
				item: this.editorItem,
			});
			const formIsValid = this.validateForm();
			return hookAllowsOpen && formIsValid;
		},
		validateForm() {
			return this.$refs.form.validate();
		},
		setValue(value) {
			this.$emit('input', value);
		},
		updateItemsToArchive(value) {
			this.itemsToArchive = value;
		},
		resetValidation() {
			this.$refs.form.resetValidation();
		},
		async save() {
			if (!this.validateForm()) return;

			this.isSaving = true;
			try {
				for (const itemToArchive of this.itemsToArchive) {
					await itemToArchive.archive({ suppressNotification: true });
				}
				if (this.beforeSaveHook) {
					this.editorItem = this.beforeSaveHook(this.editorItem);
				}

				await this.editorItem.save({
					optionName: this.optionName,
					match: this.match,
				});
				if (this.afterSaveHook) this.afterSaveHook(this.editorItem);

				this.itemsToArchive = [];
				this.$emit('input', this.editorItem);
				this.$emit('save', this.editorItem);
			} catch (error) {
				console.log(error);
			}
			this.isSaving = false;
		},
		cancel() {
			this.resetValidation();
			this.itemsToArchive = [];
			this.$emit('cancel');
		},
	},
	// created() {
	// 	console.log('optionName:', this.optionName);
	// },
};
</script>

<style scoped>
.highlighted {
	color: red;
}
</style>
